import React from "react";

interface ConfirmationDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: () => void;
  onDiscard: () => void;
}

const ConfirmationDialog = ({ isOpen, onClose, onSave, onDiscard }: ConfirmationDialogProps) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-gray-800 bg-opacity-50">
      <div className="p-6 bg-white rounded-lg shadow-lg w-80">
        <h2 className="mb-4 text-lg font-semibold">Would you like to save your progress?</h2>
        <p className="mb-6 text-sm">Information on this screen would be lost if you do not save.</p>
        <div className="flex flex-col space-y-2">
          <button className="px-4 py-2 text-white bg-black rounded-md" onClick={onSave}>
            Save
          </button>
          <button className="px-4 py-2 text-black bg-white border border-black rounded-md" onClick={onClose}>
            Continue Editing
          </button>
          <button className="px-4 py-2 text-red-600 border border-black rounded-md" onClick={onDiscard}>
            Discard Edits
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationDialog;
